import Stats from "./Stats";
import Table from "./Table";

function Categories() {
  return (
    <div>
        <Stats />
        <Table />
    </div>
  );
}

export default Categories;
